import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { unwrapResult } from '@reduxjs/toolkit'
import { IServiceLocationDetails } from '../typings'
import { ENTITY_TYPES } from '@sales-center/common'
import { getLocationDetailsForLead } from '@user/store/lead'
import { getLocationDetailsForOpportunity } from '@user/store/opportunity'

export const useGetLocationDetailsOnMount = (
  id: number | undefined,
  entityType: ENTITY_TYPES,
  locationId: number,
  branch: string | null,
  branchId: number | null,
  divisionId: string | null,
  locationTypeId: string | null,
) => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  const [locationDetails, setLocation] = useState<IServiceLocationDetails>()

  useEffect(() => {
    if (!id) {
      return
    }
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        setLocation(undefined)
        const result =
          entityType === 'LEAD'
            ? await dispatch(
                getLocationDetailsForLead({
                  entityId: id,
                  locationId: locationId,
                  branch: branch,
                  branchId: branchId,
                  divisionId: divisionId,
                  locationTypeId: locationTypeId,
                }),
              )
            : await dispatch(
                getLocationDetailsForOpportunity({
                  entityId: id,
                  locationId: locationId,
                  branch: branch,
                  branchId: branchId,
                  divisionId: divisionId,
                  locationTypeId: locationTypeId,
                }),
              )

        if (mounted) {
          if (
            getLocationDetailsForLead.fulfilled.match(result) ||
            getLocationDetailsForOpportunity.fulfilled.match(result)
          ) {
            const location = unwrapResult(result)
            setLocation(location)
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [
    dispatch,
    id,
    locationId,
    entityType,
    branch,
    branchId,
    divisionId,
    locationTypeId,
  ])

  return { locationDetailsStatus: status, locationDetails }
}
